import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import Moment from 'moment';

const OfferRow = ({ offer, activateOffer }) => {
  if (!offer) return null;

  return (
    <Row className='promotion-row'>
      <Col md='1' className='white-border'>
        {offer.externalId}
      </Col>
      <Col md='5' className='white-border'>
        <Link
          to={`/campaign/${offer.campaignId}/promotions/${offer.promotionId}/offers/${offer.id}`}
          className='row-link-active'
        >
          {offer.name}
        </Link>
      </Col>
      <Col md='1' className='white-border'>
        {Moment(offer.startDate).format('DD MMM YYYY')}
      </Col>
      <Col md='1' className='white-border'>
        {Moment(offer.endDate).format('DD MMM YYYY')}
      </Col>
      <Col md='1' className='white-border'>
        {offer.status}
      </Col>
      <Col md='1' className='white-border'>
        {offer.status !== 'Active' && offer.isReadOnly === false ? (
          <Button
            color='primary'
            name='btnFilter'
            id='btnFilter'
            onClick={() => activateOffer(offer.id)}
          >
            Activate
          </Button>
        ) : null}
      </Col>
      <Col md='1' className='white-border'>
        <Link
          to={`/campaign/${offer.campaignId}/promotions/${offer.promotionId}/offers/${offer.id}/rules`}
          className='btn btn-primary'
        >
          Add Rules
        </Link>
      </Col>
      <Col md='1' className='white-border'>
        <Link to={`/offer/${offer.id}/caffile`} className='btn btn-primary'>
          Add CAF File
        </Link>
      </Col>
    </Row>
  );
};

export default OfferRow;
